import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CourseStatusEnum } from '@edtech-ui/constants/course-status.enum';

@Component({
  selector: 'app-unpublished-course-dialog-box',
  standalone: true,
  imports: [],
  templateUrl: './unpublished-course-dialog-box.component.html',
  styleUrl: './unpublished-course-dialog-box.component.scss'
})
export class UnpublishedCourseDialogBoxComponent {

		constructor(public dialogRef: MatDialogRef<UnpublishedCourseDialogBoxComponent>,
			@Inject(MAT_DIALOG_DATA) public data: { status: CourseStatusEnum , courseId:string}
		) { }
	
		onCancel(): void {
			this.dialogRef.close(false);
		}
	
		onRemove(): void {
			this.dialogRef.close(true);
		}
}